"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get elapsedTime () {
        return elapsedTime;
    },
    get initTime () {
        return initTime;
    }
});
const _debug = /*#__PURE__*/ _interop_require_default(require("debug"));
const _Jobs = require("~/interface/Jobs");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const debugLog = (0, _debug.default)('nc:jobs:timings');
const initTime = ()=>{
    return {
        hrTime: process.hrtime(),
        totalHrTime: process.hrtime.bigint()
    };
};
const elapsedTime = (time, label, context)=>{
    const elapsedS = process.hrtime(time.hrTime)[0].toFixed(3);
    const elapsedMs = process.hrtime(time.hrTime)[1] / 1000000;
    const totalS = (process.hrtime.bigint() - time.totalHrTime) / BigInt(1000) / BigInt(1000) / BigInt(1000);
    if (label) debugLog(`${label}: ${elapsedS}s ${elapsedMs}ms; t=${totalS}s`, `${_Jobs.JOBS_QUEUE}${context ? `:${context}` : ''}`);
    time.hrTime = process.hrtime();
};
